__turbopack_context__.v({
  "card": "llN-fW_card",
  "cardAction": "llN-fW_cardAction",
  "form": "llN-fW_form",
  "paper": "llN-fW_paper",
  "select": "llN-fW_select",
});
